<template>
  <div class="flex flex-col">
    <label
      class="text-field-Label mb-1 font-bold"
      :class="labelSize ? labelSize : 'text-xs'"
      v-bind="props"
    >
      {{ label }} {{ required && label ? '*' : '' }}
    </label>

    <slot></slot>

    <small
      v-if="error"
      class="text-red-600"
    >
      {{ error }} &nbsp;</small
    >
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  id?: string
  label?: string
  labelSize?: string
  error?: string | null
  required?: boolean
}>()
</script>
